import { render, staticRenderFns } from "./statistical.vue?vue&type=template&id=6c9a6a80&scoped=true&"
import script from "./statistical.vue?vue&type=script&lang=js&"
export * from "./statistical.vue?vue&type=script&lang=js&"
import style0 from "./statistical.vue?vue&type=style&index=0&id=6c9a6a80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9a6a80",
  null
  
)

export default component.exports